





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ModuleFooterList } from './components';

@Component({
  components: {
    ModuleFooterList,
  },
})
export default class ModuleFooter extends Vue {
  @Prop({ type: Object, default: null })
  readonly items!: any;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/modulefooter/ModuleFooter.vue